import { Component } from '@angular/core';

@Component({
    selector: 'ah-four0four',
    templateUrl: './four0four.component.html',
    styleUrls: ['./four0four.component.scss'],
    standalone: false
})
export class Four0fourComponent { }
